import styles from './Dashboard.module.css';

import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

import React from "react";

import * as api from "../../api.js";

import { useAuth } from '../../AuthContext';
import { Events } from '../Events/Events';

export const Dashboard = () => {
    const [ loading, setLoading ] = React.useState(true);
    const [ error, setError ] = React.useState(null);
    const [ events, setEvents ] = React.useState([]);

    const { token, claims } = useAuth();

    const userIsScheduler = !!claims?.scheduler || !!claims?.admin;

    const handleSaveEvent = async (event) => {
        try {
            if (event.id == null) {
                const ret = await api.addEvent(event, token);

                if (ret?.error) {
                    setError(ret.error);

                    return;
                }
            } else {
                const ret = await api.updateEvent(event, token);

                if (ret?.error) {
                    setError(ret.error);

                    return;
                }
            }

            const eventsData = await api.getEvents(token);

            setEvents(eventsData);
        } catch (err) {
            throw new Error(err.message || 'Error saving event');
        }
    };

    const handleDeleteEvent = async (eventId) => {
        if (await api.deleteEvent(eventId, token)) {
            const eventsData = await api.getEvents(token);

            setEvents(eventsData);
        }
    };

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                const eventsData = await api.getEvents(token);

                if (eventsData.error) {
                    setError(eventsData.error);
                }

                setEvents(eventsData);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        
        fetchData();
    }, []);
    
    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <Alert variant='filled' severity="error" onClose={ () => setError(false) }>{ error }</Alert>;
    }

    return (
        <div className={ styles.dashboard }>
            <Events events={ events } readOnly={ !userIsScheduler } onSaveEvent={ handleSaveEvent } onDeleteEvent={ handleDeleteEvent } />
        </div>
    );
};